/**
 * Utility functions for extracting assignment information from emails
 */

/**
 * Extract file ID patterns from text
 * Supports patterns like: CB25US004378-2, 16-000WP-0209-2, etc.
 */
export function extractFileIdFromText(text) {
  if (!text) return null;
  
  // Common file ID patterns
  const patterns = [
    /CB\d+US\d+-\d+/gi,           // CB25US004378-2
    /\d{2}-\d{3}[A-Z]{2}-\d{4}-\d+/gi, // 16-000WP-0209-2
    /[A-Z]{2}\d{2}[A-Z]{2}\d{6}-\d+/gi, // Other CB patterns
    /\b[A-Z0-9]{2,}\d{4,}-\d+\b/gi     // Generic pattern
  ];
  
  for (const pattern of patterns) {
    const matches = text.match(pattern);
    if (matches && matches.length > 0) {
      return matches[0]; // Return first match
    }
  }
  
  return null;
}

/**
 * Extract file ID from email subject line and body
 */
export function extractFileIdFromEmail(emailSubject = '', emailBody = '') {
  const combinedText = `${emailSubject} ${emailBody}`;
  return extractFileIdFromText(combinedText);
}

/**
 * Get current selected email data from Office.js
 */
export async function getCurrentEmailData() {
  return new Promise((resolve) => {
    if (!Office?.context?.mailbox?.item) {
      resolve({ subject: '', body: '' });
      return;
    }
    
    const item = Office.context.mailbox.item;
    const subject = item.subject || '';
    
    // Get email body
    if (item.body && typeof item.body.getAsync === 'function') {
      item.body.getAsync(Office.CoercionType.Text, (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve({ subject, body: result.value || '' });
        } else {
          console.warn('Could not get email body:', result.error);
          resolve({ subject, body: '' });
        }
      });
    } else {
      resolve({ subject, body: '' });
    }
  });
}

/**
 * Extract file ID from currently selected email
 */
export async function extractFileIdFromCurrentEmail() {
  try {
    const emailData = await getCurrentEmailData();
    const fileId = extractFileIdFromEmail(emailData.subject, emailData.body);
    
    console.log('📧 Extracted from email:', {
      subject: emailData.subject,
      bodyLength: emailData.body?.length || 0,
      extractedFileId: fileId
    });
    
    return fileId;
  } catch (error) {
    console.error('Error extracting file ID from email:', error);
    return null;
  }
}